/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type GeogMap_geog$ref: FragmentReference;
declare export opaque type GeogMap_geog$fragmentType: GeogMap_geog$ref;
export type GeogMap_geog = {|
  +coordinates: $ReadOnlyArray<$ReadOnlyArray<$ReadOnlyArray<[number, number]>>>,
  +bbox: ?$ReadOnlyArray<?number>,
  +$refType: GeogMap_geog$ref,
|};
export type GeogMap_geog$data = GeogMap_geog;
export type GeogMap_geog$key = {
  +$data?: GeogMap_geog$data,
  +$fragmentRefs: GeogMap_geog$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GeogMap_geog",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "coordinates",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bbox",
      "storageKey": null
    }
  ],
  "type": "GeoJSONMultiPolygon",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '25cfeb0affd3760bdfe1456df3f73603';

export default node;
